import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import moment from 'moment'

import { useGetPatientByIdCid } from 'app/hooks/usePatient'
import Loading from 'app/components/MatxLoading/MatxLoading'

const PatientDataTable = () => {
    const { data } = useGetPatientByIdCid()

    // เก็บ header (วันที่ + ชื่อ measurement)
    const header = React.useMemo(() => {
        const s = new Set(['วันที่'])
        data?.forEach((item) => {
            item.measurements.forEach((m) => {
                s.add(m.name)
            })
        })
        return Array.from(s)
    }, [data])
    if (!data) return <Loading />

    return (
        <TableContainer sx={{ padding: 2 }} component={Paper}>
            <Table sx={{ minWidth: 680 }} aria-label="ตารางข้อมูล">
                <TableHead>
                    <TableRow>
                        {header.map((h) => (
                            <TableCell key={h}>{h}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row) => {
                        // map { SYS: "109", DIA: "81", ... }
                        const measurementMap = row.measurements.reduce(
                            (acc, m) => ({ ...acc, [m.name]: m.value }),
                            {}
                        )

                        return (
                            <TableRow key={row._id}>
                                <TableCell>
                                    {moment
                                        .unix(row.mea_timestamp)
                                        .format('DD/MM/YYYY HH:mm')}
                                </TableCell>
                                {header
                                    .filter((h) => h !== 'วันที่')
                                    .map((m) => (
                                        <TableCell key={m}>
                                            {measurementMap[m] ?? '--'}
                                        </TableCell>
                                    ))}
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default PatientDataTable
